<template>
	<div id="app">
		<topo></topo>
		<router-view />
		<rodape></rodape>
	</div>
</template>

<script>
import topo from '@/components/topo.vue';
import rodape from '@/components/rodape.vue';
import { baseRest } from '@/globalVars.js';
export default {
	name: 'appMain',
	data() {
		return {
			isHome: this.$store.getters.isHome,
		};
	},
	components: {
		topo,
		rodape,
	},
	beforeCreate() {
		this.$http
			.get(baseRest)
			.then((res) => {
				this.$store.dispatch('updateDuvidas', res.data);
			})
			.then(() => {
				this.$store.dispatch('updateLoad', true);
			});
	},
};
</script>
